  <!-- Footer -->
  <div class="footer-section" id="contacto" *ngIf="canShowBoxA">
    <div class="container mx-auto sm:px-20 overflow-hidden text-center ">
        <div class="flex flex-wrap gy-5 justify-center">
          
          <div class="md:w-1/4 sm:w-full mb-40 pr-16 pl-16">
            <div class="background-main-color p-10 h-full w-full square-info">
                <img src="./assets/img/footer/icono_oficina.webp" class="max-w-full h-auto" alt="">
                <h4 class="mt-4 text-white text-center">{{'mexoffice' | translate}}</h4>
                <p class="text-white text-center">Solfium México S.A. de C.V. The Village Juriquilla: Av. de las Ciencias 3015, Oficinas 601 y 612, Santa Fé, 76230 Juriquilla, Qro, México</p>
                <a href="tel:524428243029" class="text-white text-center">TEL +52 442 824 3029</a>
            </div>
          </div>

          <div class="md:w-1/4 w-full mb-40 pr-16 pl-16">
            <div class="background-main-color p-10 h-full w-full square-info">
                <img src="./assets/img/footer/icono_correo.webp" class="max-w-full h-auto" alt="">
                <h4 class="mt-4 text-white text-center">Email</h4>
                <a class="text-white text-center" href="mailito:info@solfium.com">info@solfium.com</a>
            </div>
          </div>
          
          <div class="md:w-1/4 sm:w-full mb-40 pr-16 pl-16">
            <div class="background-main-color p-10 h-full w-full square-info">
                <img src="./assets/img/footer/icono_oficina.webp" class="max-w-full h-auto" alt="">
                <h4 class="mt-4 text-white text-center">{{'centraloffice' | translate}}</h4>
                <p class="text-white text-center">1250 René-Lévesque Blvd W, Suite 2200
                  Montréal, QC, Canada H3B 4W8</p>
                <a href="tel:15144482152" class="text-white text-center">TEL: 1 (514) 448-2152</a>
            </div>
          </div>
          
        </div>
    </div>
    <div class="flex flex-wrap  contact-form-div" style="background-image: url('./assets/img/inicio/CONTACTANOS--Manos-de-una-mujer-sostiendo-un-celular-y-escribiendo-en-una-computadora.webp');">
      <div class="md:w-full  px-20 py-50 bg-photo-footer">
            <div class="flex flex-wrap items-center">
              <div class="md:w-2/3  mx-auto lg:w-1/2 form-data">
                <h2 class="text-center text-45">{{'contactus' | translate}}</h2>
                <form id = "footer-contact-form" name = "footer-contact-form" class="contact-form" [formGroup]="contactForm" #contactFormNgForm="ngForm">
                  <div class="relative mb-4">
                    <input
                        type="text"
                        id="name2"
                        [formControlName]="'name'"
                        class="block px-1 pb-1 pt-3 w-full text-sm text-gray-900 bg-gray-50 border-0 border-b-2 border-orange appearance-none focus:outline-none focus:ring-0 focus:border-orange peer input-bg-none" placeholder=" " />
                    <label for="name2" 
                        class="px-1 absolute text-sm text-gray-800 duration-300 transform -translate-y-8 scale-75 top-10 z-10 origin-[0] left-2.5 peer-focus:border-orange peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-10">
                        {{'name' | translate}}
                    </label>
                </div>

              <div class="relative mb-4">
                <input
                    type="text"
                    id="email2"
                    [formControlName]="'email'"
                    class="block px-1 pb-1 pt-3 w-full text-sm text-gray-900 bg-gray-50 border-0 border-b-2 border-orange appearance-none focus:outline-none focus:ring-0 focus:border-orange peer input-bg-none" placeholder=" " />
                <label for="email2" 
                    class="px-1 absolute text-sm text-gray-800 duration-300 transform -translate-y-8 scale-75 top-10 z-10 origin-[0] left-2.5 peer-focus:border-orange peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-10">
                    {{'email' | translate}}
                </label>
            </div>
 

                  <!-- <div class="form-floating floating-sol mb-4">
                    <select
                      class="form-select borderbinput"
                      id="payment"
                      aria-label="¿Cuánto pagas de servicio de luz?"
                      [formControlName]="'payment'">
                      <option value="0">¿Cuánto pagas de servicio de luz?</option>
                      <option value="200">Menos de 2000 MXN</option>
                      <option value="5000">2000- 5000 MXN</option>
                      <option value="5001">Más de 5000 MXN</option>
                    </select>
                  </div> -->

                  <!-- <div class="form-floating floating-sol mb-4">
                    <select
                      class="form-select borderbinput"
                      id="type"
                      aria-label="Comercial- residencial - industrial"
                      [formControlName]="'type'">
                      <option value="0">Comercial- residencial - industrial</option>
                      <option value="comercial">Comercial</option>
                      <option value="residencial">Residencial</option>
                      <option value="industrial">Industial</option>
                    </select>
                  </div> -->

                  <div class="relative mb-4">
                    <input
                        type="text"
                        id="city2"
                        [formControlName]="'city'"
                        class="block px-1 pb-1 pt-3 w-full text-sm text-gray-900 bg-gray-50 border-0 border-b-2 border-orange appearance-none focus:outline-none focus:ring-0 focus:border-orange peer input-bg-none" placeholder=" " />
                    <label for="city2" 
                        class="px-1 absolute text-sm text-gray-800 duration-300 transform -translate-y-8 scale-75 top-10 z-10 origin-[0] left-2.5 peer-focus:border-orange peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-10">
                        {{'state_quote' | translate}}
                    </label>
                </div>

                  <div class="relative mb-4">
                    <input
                        type="text"
                        id="phone2"
                        [formControlName]="'phone'"
                        class="block px-1 pb-1 pt-3 w-full text-sm text-gray-900 bg-gray-50 border-0 border-b-2 border-orange appearance-none focus:outline-none focus:ring-0 focus:border-orange peer input-bg-none" placeholder=" " min="1" maxlength="13" oninput="this.value = this.value.replace(/[^0-9+ ]/g, '')
                        if(this.value.length > 13) this.value = this.value.slice(0, 13)" />
                    <label for="phone2" 
                        class="px-1 absolute text-sm text-gray-800 duration-300 transform -translate-y-8 scale-75 top-10 z-10 origin-[0] left-2.5 peer-focus:border-orange peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-10">
                        {{'telephone' | translate}}
                    </label>
                </div>

                <div class="relative mb-4">
                  <input
                      type="text"
                      id="message2"
                      [formControlName]="'message'"
                      class="block px-1 pb-1 pt-3 w-full text-sm text-gray-900 bg-gray-50 border-0 border-b-2 border-orange appearance-none focus:outline-none focus:ring-0 focus:border-orange peer input-bg-none" placeholder=" " />
                  <label for="message2" 
                      class="px-1 absolute text-sm text-gray-800 duration-300 transform -translate-y-8 scale-75 top-10 z-10 origin-[0] left-2.5 peer-focus:border-orange peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-10">
                      {{'comment' | translate}}
                  </label>
                </div>

                  <div
                    class="mt-8 -mb-4{{alert.type === 'error' ? ' error':'no-error'}} text-center text-orange-600"
                    *ngIf="showAlert">
                    {{alert.message}}
                  </div>
                  <div class="flex flex-wrap ">
                    <div class="md:w-full  sm:w-full  items-center mt-1 justify-center flex">
                      <button
                        class="button-verde btn-verde-link"
                        (click)="submitForm()"
                        [disabled]="contactForm.invalid"
                      >{{'submit' | translate}}</button>
                    </div>  
                  </div>

                </form>
              </div>
            </div>
        </div>
    </div>
  </div>

<footer class="text-lg-start background-main-color text-white">
<!-- Section: Links  -->
<section class="p-40">
  <div class="container mx-auto sm:px-4 mt-5">
    <!-- Grid row -->
    <div class="flex flex-wrap  mt-3">
      <div class="md:w-2/12 sm:w-1/2 px-3">
        <a href="./index.html"> <img src="./assets/img/footer/logo-solfium-white.webp" class="max-w-full h-auto" alt="Logo image"/></a>
      </div>     
      <div class="md:w-1/4  sm:w-1/2">
        <p class="bold">{{'residential' | translate}}</p>
        <ul class="p-0">
          <li><a routerLink="/residential" fragment="experiencia-residencial">{{'ourexperience' | translate}}</a></li>
          <li><a routerLink="/residential" fragment="como-logramos">{{'achieve' | translate}}</a></li>
          <li><a routerLink="/residential" fragment="refiere-gana">{{'win' | translate}}</a></li>
          <li><a routerLink="/residential" fragment="proyectos">{{'projects' | translate}}</a></li>
        </ul>
        <p class="bold mt-20">{{'others' | translate}}</p>
        <ul class="p-0">
          <li><a href="https://pre.solfium.com" fragment="contacto">{{'contactus2' | translate}}</a></li>
          <!-- <li><a routerLink="/residential" fragment="proyectos">Preguntas frecuentes</a></li> -->
        </ul>
      </div>
      <div class="md:w-1/4  sm:w-1/2">
        <p class="bold">{{'quoter' | translate}}</p>
        <ul class="p-0">
          <li><a routerLink="/quotation">{{'residential' | translate}}</a></li>
          <li><a routerLink="/quotation">{{'commercial' | translate}}</a></li>
          <li><a routerLink="/quotation">{{'industrial' | translate}}</a></li>
        </ul>
        <p class="bold mt-20">{{'industrial' | translate}}</p>
        <ul class="p-0">
          <li><a routerLink="/industrial" fragment="experiencia-residencial">{{'ourexperience' | translate}}</a></li>
          <li><a routerLink="/industrial" fragment="beneficios-industrial">{{'benefits' | translate}}</a></li>
          <li><a routerLink="/industrial" fragment="proyectos">{{'projects' | translate}}</a></li>
          <li><a routerLink="/industrial" fragment="clientes">{{'clients' | translate}}</a></li>
        </ul>
      </div>     
      <div class="md:w-1/4  sm:w-1/2">
        <p class="bold">{{'company' | translate}}</p>
        <ul class="p-0">
          <li><a routerLink="./" fragment="solfium-app">Solfium App</a></li>
          <li><a routerLink="./" fragment="dashboard-corporativo">{{'dashboard' | translate}}</a></li>
          <li><a routerLink="/about">{{'us' | translate}}</a></li>
          <li><a routerLink="/about" fragment="consejo">{{'advisory' | translate}}</a></li>
          <li><a routerLink="/about" fragment="solfiumers">Solfiumers</a></li>
          <!-- <li><a routerLink="/industrial" fragment="clientes">Alianzas</a></li> -->
          <!-- <li><a routerLink="/industrial" fragment="clientes">Historias de éxito</a></li> -->
          <!-- <li><a>Personas y cultura</a></li> -->
          <li><a routerLink="/news">{{'notices' | translate}}</a></li>
        </ul>
      </div>     
      <div class="md:w-1/12  sm:w-full mt-3">
        <ul class="p-0 social-media-icons-list">
          <li>
            <a href="https://www.facebook.com/Solfium" target="_blank"><img src="./assets/img/footer/ICONO FACEBOOK .svg" class="max-w-full h-auto social-icon" alt="facebook icon"></a>
          </li>
          <li>
            <a target="_blank" href="https://www.instagram.com/solfium/"><img src="./assets/img/footer/ICONO INSTAGRAM.svg" class="max-w-full h-auto social-icon" alt="instagram icon"></a>
          </li>
          <li>
            <a href="https://www.linkedin.com/company/solfium/" target="_blank"><img src="./assets/img/footer/ICONO LINKEDIN.svg" class="max-w-full h-auto social-icon" alt="linkedin icon"></a>
          </li>
          <li>
            <a href="https://www.youtube.com/@solfium" target="_blank"><img src="./assets/img/footer/ICONO YOUTUBE.svg" class="max-w-full h-auto social-icon" alt="youtube icon"></a>
          </li>
        </ul>
      </div>     
    </div>
    <div class="line-divider"></div>
    <div class="flex flex-wrap">
      <div class="md:w-1/2 sm:w-full mt-3 text-white text-align-left">
        {{'rights' | translate}}
      </div>
      <div class="md:w-1/5 md:mx-1/5 sm:w-full mt-3">
        <a class="text-white text-align-left" routerLink="/privacy-policy" href="/privacy-policy">{{'privaty' | translate}}</a>
      </div>
      <div class="md:w-1/5 sm:w-full mt-3">
        <a class="text-white text-align-left" routerLink="/terms-conditions" href="/terms-conditions">{{'terms' | translate}}</a>
      </div>
    </div>
  </div>
</section>

</footer>
<!-- Footer -->